import React from "react";

import { useField } from "formik";
import { Row } from "components/Layout";
import { SubtleBadge } from "components/Badge";
import { CollapseLabel } from "components/Form";
import { pluralize } from "lib/pluralize";

interface EmailRecipientsHeaderProps {
  namespace: string;
  primaryContactEmail: string | null;
}

export function EmailRecipientsHeader(
  props: EmailRecipientsHeaderProps,
): React.JSX.Element {
  const { namespace: ns, primaryContactEmail } = props;
  const [{ value }] = useField<EmailRecipient[]>(ns);

  const numEmailRecipients = value.length;

  return (
    <Row>
      <SubtleBadge
        hasErrorBadge={numEmailRecipients === 0 || !primaryContactEmail}
      >
        Contacts
      </SubtleBadge>
      <Row alignCenter flexWrap>
        <CollapseLabel>
          {numEmailRecipients}&nbsp;
          {pluralize("Contact", numEmailRecipients)}
        </CollapseLabel>
        <CollapseLabel>
          Primary Contact: {primaryContactEmail || "Not Set"}
        </CollapseLabel>
      </Row>
    </Row>
  );
}
